/** Prefer the live query string so same-page chat switches remount the builder. */
export function resolveFlowBuilderSessionId(
  searchSessionId?: string | null,
  propSessionId?: string | null,
): string | undefined {
  const fromSearch = searchSessionId?.trim();
  if (fromSearch) return fromSearch;
  const fromProp = propSessionId?.trim();
  if (fromProp) return fromProp;
  return undefined;
}

export function flowBuilderChatHref(sessionId: string) {
  const id = sessionId.trim();
  return id ? `/flow-builder?sessionId=${encodeURIComponent(id)}` : "/flow-builder";
}

/** Stable React key so switching chats remounts builder state (no cross-chat cache). */
export function flowBuilderInstanceKey(options: {
  initialSessionId?: string;
  initialWorkflowId?: string;
  forceFresh?: boolean;
  initialPrompt?: string;
}): string {
  const sessionId = options.initialSessionId?.trim();
  if (sessionId) return `session:${sessionId}`;

  const workflowId = options.initialWorkflowId?.trim();
  if (workflowId) return `workflow:${workflowId}`;

  if (options.forceFresh) {
    return `fresh:${options.initialPrompt?.trim().slice(0, 64) ?? ""}`;
  }

  return "draft";
}
